///<reference path="./smart-mover.models.ts"/>
///<reference path="../../../common/event-emitter.ts"/>
///<reference path="collection-category.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;
    import Listener = Meevo.Components.Common.Listener;
    import MeevoEventEmitter = Meevo.Components.Common.MeevoEventEmitter;
    export import SmartMoverHiddenValue = Meevo.Model.SmartMoverHiddenValue;

    export interface ICollectionPopulateStatic {
        new(parent: ICollectionBase<any>, child: ICollectionBase<any>);
    }

    export interface ICollectionModelStatic<T> {
        new(attributes: T, options: IModelOptions<T>): ISmartMoverModel<T>;
    }

    export interface ICollectionPopulate {
        populate(): void;
    }

    export interface IModelOptions<T> {
        idKey: string;
        displayNameKey: string;
        collection: ICollectionBase<T>;
        $filter: ng.IFilterService;
        showInactiveLabel: boolean;
        inactiveLabel: string;
    }

    export interface ICollectionOptions<T> {
        CategoryModel?: typeof CollectionCategory;
        SmartMoverModel?: typeof SmartMoverModel;
        idKey?: string;
        displayNameKey?: string;
        criteria?: Dictionary<any>;
        reportModel?: Dictionary<any>;
        $filter?: ng.IFilterService;
        defaultValue?: ModelValueType[];
        smartMoverHidden?(): boolean;
        showInactiveLabel?: boolean;
        inactiveLabel?: string;
        url?: string;
        hiddenValue?: SmartMoverHiddenValue;
    }

    export interface ISmartMoverModel<T> {
        readonly id: string;
        readonly displayName: string;
        readonly isActive: boolean;
        selected: boolean;
        readonly template: string;
        readonly collection: ICollectionBase<any>;
        disabled: boolean;
        readonly className: _.Dictionary<boolean> | string[];

        get<K extends keyof T>(key: K): T[K];
    }

    export interface ISmartMoverCategoryModel<T> extends ISmartMoverModel<T> {
        opened: boolean;

        readonly isCategory: boolean;
        readonly models: ISmartMoverModel<any>[];
        readonly categoryCheckedClassName: CategoryCheckboxClassName;
        readonly selectedModelsNumber: number;

        resetModels(value?: CollectionModel<T>[]): void;

    }

    export interface ICollectionBase<T> extends MeevoEventEmitter {
        readonly selected: boolean;
        readonly selectedModels: CollectionModel<T>[];
        readonly selectedModelsLength: number;
        readonly models: CollectionModel<T>[];
        readonly value: ModelValueType[];
        readonly allSelected: boolean;

        responseList: T[];
        allModelsList: CollectionModel<T>[];
        connectedModel: ModelValueType[];
        populateClass: ICollectionPopulate;
        childCollection?: ICollectionBase<any>;
        parentCollection?: ICollectionBase<any>;

        handleResponse(items: T[]): void;
        setChildCollection<C>(childCollection: ICollectionBase<C>): void;
        setParentCollection<C>(parentCollection: ICollectionBase<C>, populateClass: ICollectionPopulate | ICollectionPopulateStatic): void;
        setSelectedValue(selected: boolean): void;
        setMoverVisibility(visible: boolean): void;
        setDisabled(disabled: boolean): void;
        updateCollectionFromModel(modelValues: ModelValueType[]): void;
        filterList(): void;
        on(eventName: CollectionEvents, listener: Listener): void;
        emit(eventName: CollectionEvents, ...args: any[]);
        setWatchers(scope: ng.IScope);
        getLowLevelModels(): ISmartMoverModel<any>[];
        addFilters(...filters: IInteractiveFilter[]): void;
        removeParent(): void;
        get(id: ModelValueType): ISmartMoverModel<T>;
        resetCollection(data: ModelValueType[]): void;
        pushObjects(list: T[]): CollectionModel<T>[];
        onModelValueChanged?: () => any;
        onModelValueChangedSoft?: () => any;
    }

    export interface IApiCollection<T> extends ICollectionBase<T> {
        fetch(dataService?: Meevo.Components.BaseClasses.IDataService): ng.IPromise<any>;
        updateCriteria(criteria: Dictionary<any>): void;
        getCriteria(): _.Dictionary<any>;
    }

    export type CollectionModel<T> = ISmartMoverModel<T> | ISmartMoverCategoryModel<T>;
    export type CollectionEvents =
        | 'sync'
        | 'all-collection-fetched'
        | 'ON_FETCH_START'
        | string
        ;
}
